import React from "react";
import classnames from "classnames";
import { PlusIcon, VerticalDotsIcon } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { uuid } from "uuidv4";

import { store } from "../../../../components/VerticalLayout/store";
import {
    setIsPlusIconClicked,
    store as generalSettingStore,
    setIsValidateArchiveOpened,
    setActions,
    setIsActionsClicked,
    setIsEdited,
    setIsLoading,
    setKey,
} from "../store";
import { generalConfigStore, setItemsDisable } from "@store";

import ErrorToast from "@components/Common/ErrorTost";

import { CustomMainColorIconButton } from "@components/Common/CustomMainColorIconButton";
import { CustomMainColorButtonWithIcon } from "@components/Common/CustomMainColorButtonWithIcon";
import {
    apiRequest,
    ArchivedLanguages,
    ArchivedLanguagesFranchise,
    AssociateLanguages,
    createLanguageItem,
    isLanguageExist,
} from "../hooks";
import { ShowSuccessToast } from "../ShowSuccessToast";
import { useFetchGlobal } from "../../../../api/hooks";
import "../index.css";

type CustomSideFilterType = {
    setIsArchivedLanguagesClicked: Function;
    isArchivedLanguagesClicked: boolean;
    modalState: any;
    setModalState: Function;
    tableState: any;
    setTableState: Function;
};

export function CustomSideFilter({
    setIsArchivedLanguagesClicked,
    isArchivedLanguagesClicked,
    setModalState,
    modalState,
    tableState,
    setTableState,
}: CustomSideFilterType) {
    const { fetchGlobal } = useFetchGlobal();
    const { t } = useTranslation();
    const { shopID, oneShop, userID, franchiseID, operatorID } = useSnapshot(
        store
    );
    const { itemsDisable } = useSnapshot(generalConfigStore);
    const {
        numberArchived,
        numberActive,
        shopsLanguagesData,
        archivedLanguageFranchise,
        isEdited,
        isActionsClicked,
        modify,
        isLoading,
    } = useSnapshot(generalSettingStore);
    let dataAssociate: any[] = [];
    if (!oneShop) {
        dataAssociate = AssociateLanguages(shopsLanguagesData);
    }
    let dataArchive: any[] = [];
    if (!oneShop) {
        dataArchive = ArchivedLanguages(shopsLanguagesData);
    } else {
        dataArchive = ArchivedLanguagesFranchise(archivedLanguageFranchise);
    }
    const uuidUser = localStorage.getItem("uuidUser");
    async function activeAllLanguage() {
        setIsLoading(true);
        toast.dismiss();
        let item: any = [];
        let objectData: any = {};
        let shopIds: any = [];
        tableState.selectedRows.forEach(async (el: any) => {
            if (el.shopId !== "0") {
                if (
                    itemsDisable.find(
                        (elem: any) =>
                            elem.shopId === el.shopId && elem.id === el.Id
                    ) === undefined
                ) {
                    item.push({
                        id: el.Id,
                        state: false,
                        shopId: el.shopId,
                    });
                }
            }

            const id = el.Id;
            if (!shopIds.includes(el.shopId.toString())) {
                shopIds.push(el.shopId.toString());
                objectData[el.shopId.toString()] = {};
            }
            Object.assign(objectData[el.shopId.toString()], {
                ...createLanguageItem(
                    el,
                    id,
                    el.shopId === "0" ? true : false,
                    false,
                    el.isFavorite,
                    el.shopId
                ),
            });
        });
        let dataLanguage = {
            userId: userID,
            shopId: [shopID],
            franchiseId: franchiseID,
            operatorId: operatorID,
            uuidUser: uuidUser,
            isShop: false,
            data: objectData,
            isMultiShop: true,
        };

        try {
            const result: any = await apiRequest(dataLanguage, fetchGlobal);
            if (result.error) {
                throw new Error("error");
            }
            if (shopID !== "0") {
                setItemsDisable(item);
                localStorage.setItem("itemsDisable", JSON.stringify(item));
            }
            ShowSuccessToast(
                `${t("The language was successfully unarchived")}`
            );
            setKey(uuid());
            setIsLoading(false);
            setTableState({
                ...tableState,
                dataIsUpdated: !tableState.dataIsUpdated,
            });
        } catch (e) {
            ErrorToast(`${t("There's an error")}`);
            setIsLoading(false);
        }
    }

    function enableAction() {
        setIsEdited(false);
        setModalState({
            ...modalState,
            isAddLanguageClicked: false,
        });
        setIsArchivedLanguagesClicked(true);
    }
    function archiveAction() {
        setIsEdited(false);
        if (tableState.selectedRows.length === 1) {
            ErrorToast(
                `${t(
                    "Attention, it is a multiple action. Please select at least two items"
                )!}`
            );
        } else
            setModalState({
                ...modalState,
                isHistoryModalOpened: !modalState.isHistoryModalOpened,
                isAddLanguageClicked: false,
            });
    }

    function archiveUnarchiveAction() {
        if (tableState.selectedRows.length === 1) {
            ErrorToast(
                `${t(
                    "Attention, it is a multiple action. Please select at least two items"
                )!}`
            );
            setIsLoading(false);
        } else {
            setIsLoading(false);
            isArchivedLanguagesClicked
                ? tableState.selectedRows.some((element: any) =>
                      dataArchive.includes(element.Id)
                  ) && !oneShop
                    ? setModalState({
                          ...modalState,
                          isModalOpened: !modalState.isModalOpened,
                          isAddLanguageClicked: false,
                      })
                    : activeAllLanguage()
                : isLanguageExist(
                      tableState,
                      dataAssociate,
                      setIsLoading,
                      setIsValidateArchiveOpened,
                      t
                  );
        }
    }

    return (
        <div className="d-flex justify-content-start align-items-center ml-2">
            {modify === true ? (
                <>
                    {modalState.isAddLanguageClicked !== true ? (
                        <span
                            onClick={() => {
                                setModalState({
                                    ...modalState,
                                    isAddLanguageClicked: !modalState.isAddLanguageClicked,
                                });
                                setTableState({
                                    dataTable: { data: [], othersData: {} },
                                    selectedRows: [] as any[],
                                    dataIsUpdated: false as boolean | number,
                                    filterActive: false,
                                    rowData: {},
                                    objectData: {},
                                    language: [] as any[],
                                    shopId: oneShop ? shopID : 0,
                                    selectedElement: {},
                                    isConsult: false,
                                });
                            }}
                            className={`${classnames("w-100 cmn_btn_openForm", {
                                "not-allowed-icon__clz":
                                    isArchivedLanguagesClicked || isLoading,
                            })}`}
                        >
                            <CustomMainColorButtonWithIcon
                                icon="PlusIcon"
                                iconPosition="left"
                                rounded
                                variant="primary"
                                style={{ marginLeft: "5px !important" }}
                            >
                                {t("Add a language")}
                            </CustomMainColorButtonWithIcon>
                        </span>
                    ) : (
                        <CustomMainColorIconButton
                            icon="PlusIcon"
                            className="lan_btn_FRreset"
                            rounded
                            disabled={
                                tableState.language.length === 0 ? false : true
                            }
                            onClick={() => {
                                if (isEdited === true)
                                    setModalState({
                                        ...modalState,
                                        isInInitializationModalOpened: true,
                                    });
                                else {
                                    setIsPlusIconClicked(true);
                                }
                            }}
                        >
                            <PlusIcon height={20} width={20} fill="white" />
                        </CustomMainColorIconButton>
                    )}
                </>
            ) : null}
            <VerticalDotsIcon
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                style={{ cursor: "pointer" }}
                height={25}
                width={25}
                fill="black"
                className="cmn_drp_FRmenu"
            />
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <div
                    style={{ cursor: "pointer" }}
                    className={classnames(
                        "dropdown-item cmn_btn_FRlistActivated pl-1 "
                    )}
                    onClick={() => {
                        setIsArchivedLanguagesClicked(false);
                    }}
                >
                    {t("Enabled language(s)")}({numberActive})
                </div>
                <div
                    style={{ cursor: "pointer" }}
                    className={classnames(
                        "dropdown-item cmn_btn_FRlistArchived pl-1 "
                    )}
                    onClick={() => {
                        if (isEdited === true) {
                            setIsActionsClicked(!isActionsClicked);
                            setActions(() => {
                                enableAction();
                            });
                        } else {
                            enableAction();
                        }
                    }}
                >
                    {t("Archived language(s)")}({numberArchived})
                </div>
                <div
                    style={{ cursor: "pointer" }}
                    className={`${classnames(
                        "dropdown-item cmn_btn_FRhistory pl-1",
                        {
                            "not-allowed-icon__clz":
                                tableState.selectedRows.length === 0 ||
                                isLoading,
                        }
                    )}`}
                    onClick={() => {
                        if (isEdited === true) {
                            setIsActionsClicked(!isActionsClicked);
                            setActions(() => {
                                setIsEdited(false);
                                archiveAction();
                            });
                        } else {
                            archiveAction();
                        }
                    }}
                >
                    {t("Historical")}
                </div>
                {modify === true ? (
                    <>
                        <div
                            style={{ cursor: "pointer" }}
                            className={`${classnames(
                                "dropdown-item cmn_btn_FRarchived cmn_btn_FRunarchive pl-1",
                                {
                                    "not-allowed-icon__clz":
                                        isLoading ||
                                        tableState.selectedRows.length === 0 ||
                                        (isArchivedLanguagesClicked &&
                                            oneShop &&
                                            tableState.selectedRows.some(
                                                (element: any) =>
                                                    dataArchive.includes(
                                                        element.Id
                                                    )
                                            )),
                                }
                            )}`}
                            onClick={(e: any) => {
                                setIsLoading(true);
                                if (isEdited === true) {
                                    setIsLoading(false);
                                    setIsActionsClicked(!isActionsClicked);
                                    setActions(() => {
                                        setIsEdited(false);
                                        archiveUnarchiveAction();
                                    });
                                } else {
                                    archiveUnarchiveAction();
                                }
                            }}
                        >
                            {isArchivedLanguagesClicked
                                ? t("Unarchive")
                                : t("Archive")}
                        </div>
                    </>
                ) : null}
            </div>
        </div>
    );
}
